import React from 'react';
import { useInput } from 'react-admin';
import { ServiceProviderSelector } from './ServiceProviderSelector';

interface ServiceProviderFieldProps {
  source: string;
  label?: string;
  validate?: any[];
}

export const ServiceProviderField: React.FC<ServiceProviderFieldProps> = ({
  source,
  label,
  validate,
}) => {
  const {
    field: { value, onChange },
  } = useInput({ source, validate });

  return (
    <ServiceProviderSelector source={source} label={label} value={value} onChange={onChange} />
  );
};
